import { Button, Stack } from '@mui/material'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { DiskPage } from '../../pages/InternalPage/DiskPage/DiskPage'
import { useProfileStore } from '../../store/storeProfile'
import { useRequestsStore } from '../../store/storeRequests'

export const StorageChoiceFilesDialog = ({ open, handleClose, handleSubmit }) => {
    const { isLoadingCreateStorageTariffUser } = useProfileStore((state) => state)
    const { filesByStorage } = useRequestsStore((state) => state)
    return (
        <ModalDialogWrapper
            sx={{
                '.MuiPaper-root': {
                    maxWidth: '1088px',
                    width: '100%',
                },
            }}
            footerActions={
                <Stack direction="row" gap={2} width="100%" justifyContent="flex-end">
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        disabled={isLoadingCreateStorageTariffUser}>
                        Отмена
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!filesByStorage?.length}>
                        Добавить
                    </Button>
                </Stack>
            }
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title="Мой Диск">
            <DiskPage isChoiceFilesDialog={true} />
        </ModalDialogWrapper>
    )
}
